angular.module('logbook')
.directive('customPagination', [function()
{
	return {
		restrict: 'E',
		template: require('./custom-pagination.html'),
		
		scope: {
			onBind: '=',
			onPageChange: '=',
			numPages: '='
		},
		
		link: {
			post: function(scope, elem, attr)
			{
				scope.pages = { length: scope.numPages };
				
				scope.currentPage = 1;
				scope.selectPage = function(pageNumber)
				{
					if (pageNumber === '')
						return;
					
					pageNumber = parseInt(pageNumber);
					if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > scope.numPages || pageNumber === scope.currentPage)
					{
						if (pageNumber < 1 || isNaN(pageNumber))
							scope.currentPage = 1;
						else if (pageNumber > scope.numPages)
							scope.currentPage = scope.numPages;
						
						return;
					}
					
					scope.currentPage = pageNumber;
					if (typeof scope.onPageChange === 'function')
						scope.onPageChange(pageNumber);
				};
				
				if (typeof scope.onBind === 'function')
					scope.onBind(scope);
			}
		}
	}
}]);